module.exports = __webpack_public_path__ + "img/queue.5186d7f4.png";